import {
  Directive,
  ElementRef,
  Renderer2,
  OnInit,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[appAppBrowserDetect]',
  standalone: true,
})
export class AppBrowserDetectDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    // const userAgent = navigator.userAgent;
    // console.log('userAgent', userAgent);

    // if (userAgent.includes('Edg')) {
    //   console.log('edge');
    //   this.renderer.addClass(this.el.nativeElement, 'edge-browser');
    // } else if (userAgent.includes('Chrome')) {
    //   console.log('chrome');
    //   this.renderer.addClass(this.el.nativeElement, 'chrome-browser');
    // }
    this.applyZoomFix();
    this.applyBrowserSpecificStyles();
  }

  @HostListener('window:resize')
  onResize() {
    this.applyZoomFix();
    //this.applyBrowserSpecificStyles();
  }

  private applyBrowserSpecificStyles() {
    const ua = navigator.userAgent;
    if (ua.includes('Edg')) {
      this.renderer.addClass(this.el.nativeElement, 'edge-browser');
    } else if (ua.includes('Chrome')) {
      this.renderer.addClass(this.el.nativeElement, 'chrome-browser');
    }
  }

  private initialZoomLevel: number = window.devicePixelRatio;

  //final
  private applyZoomFix() {
    const currentZoomLevel = window.devicePixelRatio;
    console.log(
      'Initial Zoom:',
      this.initialZoomLevel,
      'Current Zoom:',
      currentZoomLevel
    );

    if (Math.abs(currentZoomLevel - this.initialZoomLevel) > 0.01) {
      this.renderer.addClass(this.el.nativeElement, 'scroll-enabled');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'scroll-enabled');
    }
  }
}
